import React from "react";
import "./GenericHeading.scss";
const GenericHeading = ({ title }) => {
  return <div className="genericHeading md:pt-16">{title}</div>;
};

export default GenericHeading;
